import { FormattedMessage } from 'react-intl'
import React from 'react'
import classNames from 'classnames'
import logo1x from '../../images/logo.png'
import logo2x from '../../images/logo@2x.png'
import { translationsShared } from '../translations/translationsShared'

const LogoCenter: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={classNames('flex flex-col items-center', className)}>
      <img
        srcSet={`${logo1x} 1x, ${logo2x} 2x`}
        alt="ZagZag"
        className="rounded-full bg-black p-3"
      />
      <h1 className="mb-2 mt-4 text-xl">
        <FormattedMessage {...translationsShared.logoTitle} />
      </h1>
      <h2 className="text-md">
        <FormattedMessage {...translationsShared.logoSubtitle} />
      </h2>
    </div>
  )
}

export { LogoCenter }
